import { inject, NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CreatePlayerRoutingComponent } from "./create-player-routing.component";
import { EditPlayerComponent } from "./edit-player.component";
import { PlayersGridComponent } from "./players-grid.component";
import { SelfRegisterPlayerComponent } from "@project/player/self-register-player.component";
import { EditPlayerTabsComponent } from "./edit-player-tabs.component";
import { UserHelperService } from "@main/users/user-helper.service";
import { Permissions } from "@main/permissions/permissions";

const routes: Routes = [
    {
        path: "",
        component: PlayersGridComponent,
        data: { title: "Patients" }
    },
    {
        path: "edit/:id",
        component: EditPlayerTabsComponent,
        children: [
            {
                path: "",
                component: EditPlayerComponent,
                data: { title: "Edit Patient" }
            },
            /** TODO: Review whether this route is needed - the routed component is empty */
            // {
            //     path: "granted-organizations",
            //     data: { title: "Organisations with Access Granted" },
            //     component: GrantedOrganizationsComponent,
            //     providers: [PlayerGrantedOrganizationsService],
            //     canActivate: [
            //         () => {
            //             const userHelperService = inject(UserHelperService);
            //             return userHelperService.hasPermission(Permissions.ManageOrganisationGrantAccess);
            //         }
            //     ]
            // }
        ]
    },
    {
        path: "new",
        component: CreatePlayerRoutingComponent,
        data: { title: "Create Patient" }
    },
    {
        path: "new/self-register",
        component: SelfRegisterPlayerComponent,
        data: { title: "Self Register" }
    },
    {
        path: "merge",
        loadChildren: () => import("../merge-patient/merge-patients-routes").then(m => m.MERGE_PATIENT_ROUTES),
        canActivate: [
            () => {
                const userHelper = inject(UserHelperService);
                return userHelper.hasPermission(Permissions.WritePatient);
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PlayerRoutingModule {}
